var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#34A353;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,0C8.1,0,0,8.1,0,18s8.1,18,18,18s18-8.1,18-18S27.9,0,18,0z M33.6,18c0,8.6-7,15.6-15.6,15.6 S2.4,26.6,2.4,18S9.4,2.4,18,2.4S33.6,9.4,33.6,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,11.2L15,22.3l-5.1-5.1c-0.5-0.5-1.2-0.5-1.7,0C8,17.4,7.9,17.7,7.9,18c0,0.3,0.1,0.6,0.4,0.8l5.9,5.9 c0.2,0.2,0.5,0.4,0.8,0.4c0.3,0,0.6-0.1,0.8-0.4l11.9-11.9c0.2-0.2,0.4-0.5,0.4-0.8c0-0.3-0.1-0.6-0.4-0.8 C27.3,10.8,26.6,10.8,26.1,11.2L26.1,11.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.2349a83f58eca3322f4f9706f795f530.svg";
export { ForwardRef as ReactComponent };